"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mid = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _midCore = require("./mid-core");

var _errors = require("./errors");

var _support = require("./support");

/* eslint-disable no-undef */

/**
 * Sanity check the configuration.
 *
 * @param {object} config - the configuration for mid-sdk
 * @return {void} - throws an exception if the configuration is bad
 */
var checkConfig = function checkConfig(config) {
  var errors = [];

  if (!config) {
    errors.push('config is missing, aborting mid-sdk startup');
  } else {
    try {
      if (!config.redirectUrl) {
        errors.push('redirectUrl must be populated');
      } else {
        // eslint-disable-next-line no-new
        new URL(config.redirectUrl).toString();
      }
    } catch (err) {
      errors.push("redirectUrl \"".concat(config.redirectUrl, "\" is not valid"));
    }

    try {
      if (!config.logoutRedirectUrl) {
        errors.push('logoutRedirectUrl must be populated');
      } else {
        // eslint-disable-next-line no-new
        new URL(config.logoutRedirectUrl).toString();
      }
    } catch (err) {
      errors.push("logoutRedirectUrl \"".concat(config.logoutRedirectUrl, "\" is not valid"));
    }

    if (!config.loginWidget) {
      errors.push('loginWidget must be configured');
    }

    if (!config.drivers) {
      errors.push('drivers must be configured');
    }
  }

  if (errors.length > 0) {
    var errorJson = JSON.stringify(errors);
    console.error("failed to set up mid-sdk, errors ".concat(errorJson));

    var _makeErrors = (0, _errors.makeErrors)(config.errors),
        ERR_MISCONFIGURATION = _makeErrors.ERR_MISCONFIGURATION;

    throw new Error(ERR_MISCONFIGURATION(errors.join(',')));
  }
};
/**
 * McKinsey ID Public API Surface
 */


var Mid = /*#__PURE__*/function () {
  /**
   * Build the Mid object
   *
   * @param {MidConfig} config the configuration for McKinsey ID
   */
  function Mid(config) {
    (0, _classCallCheck2["default"])(this, Mid);
    checkConfig(config);
    this.core = new _midCore.MidCore(this, config); // Save class information so it doesn't get lost in transpiling

    this.isAuthed = this.isAuthed.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.refresh = this.refresh.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
  }
  /**
   * Is this user authenticated and has a tenant?
   *
   * Note that this only requires that the user have a valid tenant and access token. Not that the token
   * is valid for YOUR solution. Please do not expose sensitive information before verifying that the access
   * token is valid on the server-side.
   *
   * @returns {Promise<boolean>} is the user authenticated?
   */


  (0, _createClass2["default"])(Mid, [{
    key: "isAuthed",
    value: function () {
      var _isAuthed = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.core.isAuthed();

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isAuthed() {
        return _isAuthed.apply(this, arguments);
      }

      return isAuthed;
    }()
    /**
     * @return {*} Decode the access token and return the information inside
     */

  }, {
    key: "accessInfo",
    value: function accessInfo() {
      return (0, _support.getAccessInfo)();
    }
    /**
     * @return {*} Decode the id token and return the payload
     */

  }, {
    key: "idInfo",
    value: function idInfo() {
      return (0, _support.getIdInfo)();
    }
    /**
     * @return {*} the access Token used to authenticate against a remote api
     */

  }, {
    key: "accessToken",
    value: function accessToken() {
      return (0, _support.getAccessToken)();
    }
    /**
     * @return {*} the id Token used to hold the authenticated party's identity
     */

  }, {
    key: "idToken",
    value: function idToken() {
      return (0, _support.getIdToken)();
    }
    /**
     * Perform an authentication. This function suspends until a valid authenticated token exists.
     *
     * @return {Promise<MidAuthnContext>} - upon a successful authentication, a MidAuthnContext
     */

  }, {
    key: "login",
    value: function () {
      var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.core.login();

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }()
    /**
     * Attempt to refresh the user's access token
     *
     * @return {Promise<void>} an asynchronous attempt to refresh the access token
     */

  }, {
    key: "refresh",
    value: function () {
      var _refresh = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.core.refresh();

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
    /**
     * Perform a logout. Destroys all local McKinsey ID information.
     *
     * @return {Promise<void>} - a suspended promise that resolves upon completion of logout.
     */

  }, {
    key: "logout",
    value: function () {
      var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.core.logout();

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
    /**
     * Get user info.
     *
     * @return {Promise<UserInfo>} - UserInfo
     */

  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.core.getUserInfo();

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
  }]);
  return Mid;
}();

exports.Mid = Mid;